import { render, staticRenderFns } from "./antiFraud.vue?vue&type=template&id=4fefd3e4&scoped=true"
import script from "./antiFraud.vue?vue&type=script&lang=js"
export * from "./antiFraud.vue?vue&type=script&lang=js"
import style0 from "./antiFraud.vue?vue&type=style&index=0&id=4fefd3e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fefd3e4",
  null
  
)

export default component.exports